// 단일 진실 소스: 이벤트 타입의 값, 한글 라벨, 색상(hex)
// 새 타입 추가 시 이 파일 + tokens.css + 서버 Event.js enum(+ server/utils/agendaItem.js 의 색) 만 수정하면 됨.
// (el-tag type 매핑 getEventTypeTagType 과 별칭 getEventTypeText 는 쓰는 곳이 없어져 지웠다)

export const EVENT_TYPE_LIST = [
  { value: 'work',       label: '업무', color: '#2563eb' },
  { value: 'substitute', label: '대직', color: '#16a34a' },
  { value: 'fieldwork',  label: '외근', color: '#7c3aed' },
  { value: 'inspection', label: '점검', color: '#ea580c' },
  { value: 'dayoff',     label: '휴무', color: '#6b7280' },
  { value: 'vacation',   label: '휴가', color: '#dc2626' }
]

const MAP = Object.fromEntries(EVENT_TYPE_LIST.map((t) => [t.value, t]))
const FALLBACK = MAP.work

export function getEventTypeColor(type) {
  return (MAP[type] || FALLBACK).color
}

export function getEventTypeLabel(type) {
  return (MAP[type] || FALLBACK).label
}
